/**
 * ID — D14 rev.2: prefisso + 10 caratteri Crockford base32 minuscoli da CSPRNG.
 * Le informazioni semantiche vivono nei CAMPI, non negli ID (D14: un ID semantico/ordinale
 * collide tra device e rompe la merge). Alfabeto Crockford: esclusi i, l, o, u.
 */
export const ID_ALPHABET = "0123456789abcdefghjkmnpqrstvwxyz";

export type IdPrefix = "ev" | "u" | "s" | "set" | "tmpl" | "pg" | "c" | "dev";

// prefissi del contratto (modello-dati §2.2) + dev (device_id: tie-break merge, ratificato D48)
const PREFIXES: readonly IdPrefix[] = ["ev", "u", "s", "set", "tmpl", "pg", "c", "dev"];

export function newId(prefix: IdPrefix): string {
  const bytes = crypto.getRandomValues(new Uint8Array(10));
  let out = "";
  for (const b of bytes) {
    // 256 % 32 === 0 → nessun modulo bias
    out += ID_ALPHABET[b % 32] as string;
  }
  return `${prefix}_${out}`;
}

export function isId(value: string, prefix?: IdPrefix): boolean {
  const m = /^([a-z]+)_([0-9abcdefghjkmnpqrstvwxyz]{10})$/.exec(value);
  if (!m) return false;
  const p = m[1] as string;
  return prefix ? p === prefix : (PREFIXES as readonly string[]).includes(p);
}
